import './global.less'
import 'core-js/features/string/match-all'

import { ApolloProvider } from '@apollo/client'
import { createErrorBoundary } from '@web/react-common'
import axios, { AxiosError } from 'axios'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { NewVersionBanner, ScrollTop } from '@/components'
import { App } from '@/modules/app'
import { Login } from '@/modules/user/login'
import { alert } from '@/utils/alert'

import { apolloClient } from './gql'

// @ts-ignore
window.process = { cwd: () => '' }

axios.interceptors.response.use(undefined, (err: AxiosError) => {
  if (err.response?.status === 401) {
    window.location.href = '/'
  }
  return Promise.reject(err)
})

const ErrorBoundary = createErrorBoundary(alert)

const Main = () => {
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <Login>
            <>
              <NewVersionBanner />
              <ScrollTop />
              <App />
            </>
          </Login>
        </BrowserRouter>
      </ApolloProvider>
    </ErrorBoundary>
  )
}

ReactDOM.render(<Main />, document.getElementById('react-root'))
